// 系统路由
const routes = [
	{
		name: 'layout',
		path: '/',
		component: () => import('layout/index.vue'),
		//redirect: tool.data.get('MENU') ? tool.data.get('MENU')[0].children[0].path : config.DASHBOARD_URL,
		//redirect: config.DASHBOARD_URL,
		children: []
	},
	{
		path: '/codeCallback',
		component: () => import('@/pagesDefault/auth/codeCallback.vue'),
		meta: {
			title: '单点登录'
		}
	}
]
export default routes
